// extracted by mini-css-extract-plugin
var _1 = "FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
export { _1 as "FileIcon" }
